const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    maxWidth: '400px',
    marginBottom: '24px'
  },
  avatar: {
    marginRight: '20px',
    flexShrink: 0
  },
  actions: {
    marginBottom: '10px'
  }
}

export default styles
